import getConfig from 'next/config'

const configs = () => getConfig?.()?.publicRuntimeConfig || {}

export const shopHelpPath = (imgPath: string, c = configs()) =>
  `${c.cdnBasePath}${c.cdnShopHelp}${c.cdnImage}${imgPath}`

export const listRouterStatic = [
  'shipping-policy',
  'return-policy',
  'terms-of-service',
  'privacy',
  'payment-methods',
  'about-us'
]

export const isShowAboutUS = () => {
  const domain = typeof window !== 'undefined' ? window?.location?.hostname : ''
  const arrDomain = [
    'noerror.onselless.dev',
    'quantity.onselless.dev',
    'rosiaa.com',
    'hansihandy.com',
    'pinkchloe.com',
    'julidostore.us',
    'avacharm.com'
  ]
  return arrDomain?.includes(domain)
}
